// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--primaryColor: #8C60BF;--page_bg: #f1efee;--lines: #ebedf1;--primaryHover: #7e56ac;--secondaryHover: #f4eff9;--primaryActive: #704d99;--secondaryActive: #e8dff2;--disputeFieldsBg:#f8fbf9}\n", ""]);
// Exports
module.exports = exports;
